import { videosMediaFilesType } from "../static/videosMediaFilesType";

export const isVideo = (filePath: string) => {
  let videoType = filePath.split(".").pop();
  return videosMediaFilesType.includes(videoType!);
};
